// export DsfFormPickUp from './formPickUp.vue'

export const DsfFormPickUp=dsf.defineLazyComponent('DsfFormPickUp',()=>require('./formPickUp.vue'))
